import React, { useMemo } from 'react';
import { Button } from 'antd';
import { WhatsAppOutlined } from '@ant-design/icons';
import { useAppSelector, useWhatsAppNumbers } from 'src/hooks';
import { AppI } from 'src/redux';
import styles from './WhatsAppBubble.module.css';

const WhatsAppBubble = () => {
   const { locale, country } = useAppSelector(({ app }: { app: AppI }) => app);
   const { numbers } = useWhatsAppNumbers();

   const whatsappLink: string = useMemo(() => {
      // Format phone number for WhatsApp (remove spaces and special chars)
      const formatPhone = (phone: string, countryCode: string) => {
         const formatted = phone.replace(/\s+/g, '').replace(/[()+-]/g, '');
         return `https://wa.me/${countryCode}${formatted}`;
      };

      // Use Remote Config number only if country is Mexico
      const mxPhone = country === 'mx' ? (numbers?.mx ?? '55 1079 0688') : '55 1079 0688';
      const coPhone = country === 'co' ? (numbers?.co ?? '+57 310 769 9490') : '+57 310 769 9490';
      const usPhone = country === 'en' ? (numbers?.us ?? '(210) 878-7819') : '(210) 878-7819';

      const whatsappLinks: Record<string, string> = {
         'es-ES': formatPhone(mxPhone, '52'),
         'en': formatPhone(usPhone, '1'),
         'es': formatPhone(mxPhone, '52'),
         'co': formatPhone(coPhone, '57'),
      };

      return whatsappLinks[locale as string] || whatsappLinks['es'];
   }, [locale, country, numbers]);

   return (
      <a
         href={whatsappLink}
         target='_blank'
         rel='noreferrer'
         className={styles.whatsapp_bubble}
      >
         <Button
            shape='circle'
            icon={<WhatsAppOutlined style={{ color: '#FFFFFF', fontSize: 24 }} />}
            size='large'
            style={{ backgroundColor: '#25D366', border: 'none' }}
         />
      </a>
   );
};

export default WhatsAppBubble;
